/** @format */

import {METHOD_CREDIT_CARD, METHOD_NET30} from 'frontier-constants';
import update from 'immutability-helper';
import SuperAgent from 'superagent';
import React from 'react';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';

export default function withPaymentsHandler(ComponentContainer) {
    return class extends React.Component {
        static contextType = CartCheckoutContext;
        static propTypes = {};

        constructor(props) {
            super(props);
            this.state = {
                billingMethodId: props.billing_method_id,
                isNet30Approved: false,
                paymentProfiles: [],
                editing: false, // Are we trying to change the shipping method
                loading: false, // Are we loading new shipping methods
                pending: false, // Are we trying to save
                error: false,
                formData: {}
            };
        }

        componentDidMount() {
            if (!this.props.payment_profile_id && this.props.billing_method_id != METHOD_NET30) {
                this.handleGetPaymentProfiles();
            }
        }

        handleGetPaymentProfiles = () => {
            this.setState({
                billingMethodId: METHOD_CREDIT_CARD,
                isNet30Approved: false,
                shippingMethods: [],
                loading: true
            });

            SuperAgent.get('/carts/get-payment-profiles')
                .set('Accept', 'application/json')
                .end((err, response) => {
                    this.setState({
                        isNet30Approved: response.body.isNet30Approved,
                        paymentProfiles: response.body.paymentProfiles,
                        loading: false,
                        editing: true
                    });
                });
        };

        handleChooseProfile = profile => {
            this.setState({editing: false, shippingMethods: []}, () => {
                const {id, account_type_id, account_last_four, label} = profile;
                const cartUpdateTarget = {};

                cartUpdateTarget.cart = {
                    billing_account_last_four: {$set: account_last_four},
                    billing_account_type_id: {$set: account_type_id},
                    billing_method_id: {$set: METHOD_CREDIT_CARD},
                    payment_profile_label: {$set: label},
                    payment_profile_id: {$set: id}
                };

                this.context.onChange(cartUpdateTarget);
            });
        };

        handleChangeBillingMethod = (is_net_30_or_bill_me, ppId) => {
            let value = is_net_30_or_bill_me;
            if (typeof is_net_30_or_bill_me !== 'boolean')
                value = is_net_30_or_bill_me.target.checked ? true : false;

            const billLaterType = METHOD_NET30;

            this.setState(
                {
                    billingMethodId: value ? billLaterType : METHOD_CREDIT_CARD,
                    editing: value ? false : true
                },
                () => {
                    const cartUpdateTarget = {};
                    cartUpdateTarget.cart = {
                        billing_method_id: {$set: value ? billLaterType : METHOD_CREDIT_CARD},
                        billing_account_last_four: {$set: ''},
                        billing_account_type_id: {$set: ''},
                        payment_profile_label: {$set: ''},
                        payment_profile_id: {$set: ppId}
                    };

                    this.context.onChange(cartUpdateTarget);
                }
            );
        };

        handleChange = updateTarget => {
            this.setState(update(this.state, updateTarget));
        };

        handleSavePaymentProfile = ({response, cardData}) => {
            this.setState({
                error: false,
                saving: true
            });

            const formData = {...this.state.formData};
            formData.billing_address_id = this.props?.props?.cart?.billing_address_id;

            if (response?.opaqueData) {
                formData.opaqueData = response?.opaqueData;
            }

            if (cardData) {
                formData.account_number = cardData?.cardNumber.trim().slice(-4);
                formData.expires_year = cardData?.year;
                formData.expires_month = cardData?.month;
                formData.card_code = cardData?.cardCode;
                formData.card_type = cardData?.cardType;
            }

            SuperAgent.post('/carts/save-nonce-payment-profile')
                .set('Accept', 'application/json')
                .send(formData)
                .end((err, response) => {
                    if (err || !response.body) {
                        this.setState({
                            error: response ? response.body : err,
                            saving: false
                        });
                    } else {
                        this.setState({
                            editing: false,
                            saving: false,
                            formData: {},
                            done: true,
                            paymentProfiles: [...this.state.paymentProfiles, response.body]
                        });

                        const cartUpdateTarget = {};
                        cartUpdateTarget.cart = {
                            billing_account_last_four: {$set: response.body.account_last_four},
                            billing_account_type_id: {$set: response.body.account_type_id},
                            payment_profile_label: {$set: response.body.label},
                            billing_method_id: {$set: METHOD_CREDIT_CARD},
                            payment_profile_id: {$set: response.body.id}
                        };

                        this.context.onChange(cartUpdateTarget);
                    }
                });
        };

        render() {
            const props = {...this.props};

            props.onChangeBillingMethod = this.handleChangeBillingMethod;
            props.onGetPaymentProfiles = this.handleGetPaymentProfiles;
            props.onSavePaymentProfile = this.handleSavePaymentProfile;
            props.onChooseProfile = this.handleChooseProfile;
            props.onChange = this.handleChange;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
}
